/* tslint:disable */
/* eslint-disable */
/**
 * AllOfUs Workbench API
 * The API for the AllOfUs workbench.  Throughout, we use integer/int64 in preference to string/date-time because Swagger\'s date formatting is inconsistent between server and client. Time values are stored as milliseconds since the UNIX epoch.  Note: all requests tagged as \"cron\" must have the header X-Appengine-Cron: true, which app engine itself only sets when invoking as a cronjob. See https://cloud.google.com/appengine/docs/standard/java/config/cron#securing_urls_for_cron and o.p.w.interceptors.CronInterceptor which implements the header check. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  EmptyResponse,
  ErrorResponse,
  RecentWorkspaceResponse,
  StartWorkspaceRecoveryRequest,
  VwbPodDescription,
  VwbWorkspaceListResponse,
  Workspace,
  WorkspaceResponse,
  WorkspaceResponseListResponse,
} from '../models';
import {
    EmptyResponseFromJSON,
    EmptyResponseToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    RecentWorkspaceResponseFromJSON,
    RecentWorkspaceResponseToJSON,
    StartWorkspaceRecoveryRequestFromJSON,
    StartWorkspaceRecoveryRequestToJSON,
    VwbPodDescriptionFromJSON,
    VwbPodDescriptionToJSON,
    VwbWorkspaceListResponseFromJSON,
    VwbWorkspaceListResponseToJSON,
    WorkspaceFromJSON,
    WorkspaceToJSON,
    WorkspaceResponseFromJSON,
    WorkspaceResponseToJSON,
    WorkspaceResponseListResponseFromJSON,
    WorkspaceResponseListResponseToJSON,
} from '../models';

export interface WorkspacesApiDeleteWorkspaceRequest {
    workspaceNamespace: string;
    terraName: string;
}

export interface WorkspacesApiGetWorkspaceRequest {
    workspaceNamespace: string;
    terraName: string;
}

export interface WorkspacesApiGetWorkspaceByNamespaceRequest {
    workspaceNamespace: string;
}

export interface WorkspacesApiRequestWorkspaceRecoveryRequest {
    namespace: string;
    podId: string;
}

export interface WorkspacesApiStartWorkspaceRecoveryOperationRequest {
    namespace: string;
    startWorkspaceRecoveryRequest: StartWorkspaceRecoveryRequest;
}

export interface WorkspacesApiUpdateRecentWorkspacesRequest {
    workspaceNamespace: string;
    terraName: string;
}

/**
 * 
 */
export class WorkspacesApi extends runtime.BaseAPI {

    /**
     * Deletes the workspace definition with the specified ID and namespace
     */
    async deleteWorkspaceRaw(requestParameters: WorkspacesApiDeleteWorkspaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmptyResponse>> {
        if (requestParameters.workspaceNamespace === null || requestParameters.workspaceNamespace === undefined) {
            throw new runtime.RequiredError('workspaceNamespace','Required parameter requestParameters.workspaceNamespace was null or undefined when calling deleteWorkspace.');
        }

        if (requestParameters.terraName === null || requestParameters.terraName === undefined) {
            throw new runtime.RequiredError('terraName','Required parameter requestParameters.terraName was null or undefined when calling deleteWorkspace.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aou_oauth", []);
        }

        const response = await this.request({
            path: `/v1/workspaces/{workspaceNamespace}/{terraName}`.replace(`{${"workspaceNamespace"}}`, encodeURIComponent(String(requestParameters.workspaceNamespace))).replace(`{${"terraName"}}`, encodeURIComponent(String(requestParameters.terraName))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmptyResponseFromJSON(jsonValue));
    }

    /**
     * Deletes the workspace definition with the specified ID and namespace
     */
    async deleteWorkspace(workspaceNamespace: string, terraName: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmptyResponse> {
        const response = await this.deleteWorkspaceRaw({ workspaceNamespace: workspaceNamespace, terraName: terraName }, initOverrides);
        return await response.value();
    }

    /**
     */
    async getUserPodsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<VwbPodDescription>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aou_oauth", []);
        }

        const response = await this.request({
            path: `/v1/workspaces/pods`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(VwbPodDescriptionFromJSON));
    }

    /**
     */
    async getUserPods(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<VwbPodDescription>> {
        const response = await this.getUserPodsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Returns the workspaces edited by the user in descending order of update time
     */
    async getUserRecentWorkspacesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RecentWorkspaceResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aou_oauth", []);
        }

        const response = await this.request({
            path: `/v1/workspaces/user-recent-workspaces`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RecentWorkspaceResponseFromJSON(jsonValue));
    }

    /**
     * Returns the workspaces edited by the user in descending order of update time
     */
    async getUserRecentWorkspaces(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RecentWorkspaceResponse> {
        const response = await this.getUserRecentWorkspacesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Returns all RW2.0 workspaces the current user has access to.
     */
    async getVwbWorkspacesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VwbWorkspaceListResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aou_oauth", []);
        }

        const response = await this.request({
            path: `/v1/workspaces/vwb`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VwbWorkspaceListResponseFromJSON(jsonValue));
    }

    /**
     * Returns all RW2.0 workspaces the current user has access to.
     */
    async getVwbWorkspaces(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VwbWorkspaceListResponse> {
        const response = await this.getVwbWorkspacesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Returns the workspace definition with the specified ID and namespace
     */
    async getWorkspaceRaw(requestParameters: WorkspacesApiGetWorkspaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkspaceResponse>> {
        if (requestParameters.workspaceNamespace === null || requestParameters.workspaceNamespace === undefined) {
            throw new runtime.RequiredError('workspaceNamespace','Required parameter requestParameters.workspaceNamespace was null or undefined when calling getWorkspace.');
        }

        if (requestParameters.terraName === null || requestParameters.terraName === undefined) {
            throw new runtime.RequiredError('terraName','Required parameter requestParameters.terraName was null or undefined when calling getWorkspace.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aou_oauth", []);
        }

        const response = await this.request({
            path: `/v1/workspaces/{workspaceNamespace}/{terraName}`.replace(`{${"workspaceNamespace"}}`, encodeURIComponent(String(requestParameters.workspaceNamespace))).replace(`{${"terraName"}}`, encodeURIComponent(String(requestParameters.terraName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkspaceResponseFromJSON(jsonValue));
    }

    /**
     * Returns the workspace definition with the specified ID and namespace
     */
    async getWorkspace(workspaceNamespace: string, terraName: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkspaceResponse> {
        const response = await this.getWorkspaceRaw({ workspaceNamespace: workspaceNamespace, terraName: terraName }, initOverrides);
        return await response.value();
    }

    /**
     * Returns the workspace definition with the specified namespace
     */
    async getWorkspaceByNamespaceRaw(requestParameters: WorkspacesApiGetWorkspaceByNamespaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Workspace>> {
        if (requestParameters.workspaceNamespace === null || requestParameters.workspaceNamespace === undefined) {
            throw new runtime.RequiredError('workspaceNamespace','Required parameter requestParameters.workspaceNamespace was null or undefined when calling getWorkspaceByNamespace.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aou_oauth", []);
        }

        const response = await this.request({
            path: `/v1/workspaces/{workspaceNamespace}`.replace(`{${"workspaceNamespace"}}`, encodeURIComponent(String(requestParameters.workspaceNamespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkspaceFromJSON(jsonValue));
    }

    /**
     * Returns the workspace definition with the specified namespace
     */
    async getWorkspaceByNamespace(workspaceNamespace: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Workspace> {
        const response = await this.getWorkspaceByNamespaceRaw({ workspaceNamespace: workspaceNamespace }, initOverrides);
        return await response.value();
    }

    /**
     * Returns all workspaces that a user has access to
     */
    async getWorkspacesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkspaceResponseListResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aou_oauth", []);
        }

        const response = await this.request({
            path: `/v1/workspaces`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkspaceResponseListResponseFromJSON(jsonValue));
    }

    /**
     * Returns all workspaces that a user has access to
     */
    async getWorkspaces(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkspaceResponseListResponse> {
        const response = await this.getWorkspacesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Requests archived workspace recovery by sending a recovery request email to administrators.
     */
    async requestWorkspaceRecoveryRaw(requestParameters: WorkspacesApiRequestWorkspaceRecoveryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace','Required parameter requestParameters.namespace was null or undefined when calling requestWorkspaceRecovery.');
        }

        if (requestParameters.podId === null || requestParameters.podId === undefined) {
            throw new runtime.RequiredError('podId','Required parameter requestParameters.podId was null or undefined when calling requestWorkspaceRecovery.');
        }

        const queryParameters: any = {};

        if (requestParameters.podId !== undefined) {
            queryParameters['podId'] = requestParameters.podId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aou_oauth", []);
        }

        const response = await this.request({
            path: `/v1/workspaces/{namespace}/requestRecovery`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Requests archived workspace recovery by sending a recovery request email to administrators.
     */
    async requestWorkspaceRecovery(namespace: string, podId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.requestWorkspaceRecoveryRaw({ namespace: namespace, podId: podId }, initOverrides);
    }

    /**
     * Starts archived workspace recovery flow.
     */
    async startWorkspaceRecoveryRaw(requestParameters: WorkspacesApiStartWorkspaceRecoveryOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace','Required parameter requestParameters.namespace was null or undefined when calling startWorkspaceRecovery.');
        }

        if (requestParameters.startWorkspaceRecoveryRequest === null || requestParameters.startWorkspaceRecoveryRequest === undefined) {
            throw new runtime.RequiredError('startWorkspaceRecoveryRequest','Required parameter requestParameters.startWorkspaceRecoveryRequest was null or undefined when calling startWorkspaceRecovery.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aou_oauth", []);
        }

        const response = await this.request({
            path: `/v1/workspaces/{namespace}/recovery`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StartWorkspaceRecoveryRequestToJSON(requestParameters.startWorkspaceRecoveryRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Starts archived workspace recovery flow.
     */
    async startWorkspaceRecovery(namespace: string, startWorkspaceRecoveryRequest: StartWorkspaceRecoveryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.startWorkspaceRecoveryRaw({ namespace: namespace, startWorkspaceRecoveryRequest: startWorkspaceRecoveryRequest }, initOverrides);
    }

    /**
     * Add/update user recent workspaces
     */
    async updateRecentWorkspacesRaw(requestParameters: WorkspacesApiUpdateRecentWorkspacesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RecentWorkspaceResponse>> {
        if (requestParameters.workspaceNamespace === null || requestParameters.workspaceNamespace === undefined) {
            throw new runtime.RequiredError('workspaceNamespace','Required parameter requestParameters.workspaceNamespace was null or undefined when calling updateRecentWorkspaces.');
        }

        if (requestParameters.terraName === null || requestParameters.terraName === undefined) {
            throw new runtime.RequiredError('terraName','Required parameter requestParameters.terraName was null or undefined when calling updateRecentWorkspaces.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aou_oauth", []);
        }

        const response = await this.request({
            path: `/v1/workspaces/{workspaceNamespace}/{terraName}/user-recent-workspaces/update`.replace(`{${"workspaceNamespace"}}`, encodeURIComponent(String(requestParameters.workspaceNamespace))).replace(`{${"terraName"}}`, encodeURIComponent(String(requestParameters.terraName))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RecentWorkspaceResponseFromJSON(jsonValue));
    }

    /**
     * Add/update user recent workspaces
     */
    async updateRecentWorkspaces(workspaceNamespace: string, terraName: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RecentWorkspaceResponse> {
        const response = await this.updateRecentWorkspacesRaw({ workspaceNamespace: workspaceNamespace, terraName: terraName }, initOverrides);
        return await response.value();
    }

}
